require('./bootstrap');
// require('@fortawesome/fontawesome-free/js/all.min.js');

window.modalFormSucesso = new bootstrap.Modal(document.getElementById('modalFormSucesso'));

var myModalEl = document.getElementById('modalFormSucesso')
myModalEl.addEventListener('hidden.bs.modal', function (event) {
    window.location = "/";
});

require('./components/news.js');
require('./components/missao.js');
require('./components/valores.js');
require('./components/jornada.js');
//require('./components/company-logo.js');
require('./components/modal-faca-parte.js');
// require('./components/modal-imprensa.js');
require('./components/wellness-fun.js');


whr(document).on('click', 'li.whr-item a', function(e)
{ e.preventDefault(); window.open(this.href, '_blank'); });
